import { useCallback, useRef } from 'react';

type Callback = (...args: unknown[]) => unknown;

export const useCancellableDelayedCallback = (cb: Callback, delay: number) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const cancel = useCallback(() => {
    const timeoutId = timeoutRef.current;
    if (timeoutId) {
      timeoutRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutRef]);
  const delayedCb: Callback = useCallback(
    (...args) => {
      timeoutRef.current = setTimeout(() => cb(...args), delay);
    },
    [cb, delay],
  );

  return [delayedCb, cancel];
};

export default useCancellableDelayedCallback;
